import React                from "react";
import PropTypes            from "prop-types";
import Action               from "Dashboard/Core/Action";
import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";
import useList              from "Dashboard/Hooks/List";
import Commons              from "Utils/Commons";

// Components
import ButtonEdit           from "./ButtonEdit";

// Dashboard
import Main                 from "Dashboard/Components/Core/Main";
import Content              from "Dashboard/Components/Core/Content";
import Header               from "Dashboard/Components/Header/Header";
import ActionList           from "Dashboard/Components/Header/ActionList";
import Table                from "Dashboard/Components/Table/Table";
import TableHead            from "Dashboard/Components/Table/TableHead";
import TableBody            from "Dashboard/Components/Table/TableBody";
import TableRow             from "Dashboard/Components/Table/TableRow";
import TableHeader          from "Dashboard/Components/Table/TableHeader";
import TableCell            from "Dashboard/Components/Table/TableCell";
import TableActionList      from "Dashboard/Components/Table/TableActionList";
import TableAction          from "Dashboard/Components/Table/TableAction";
import TablePaging          from "Dashboard/Components/Table/TablePaging";
import DeleteDialog         from "Dashboard/Components/Dialogs/DeleteDialog";



/**
 * The Button List
 * @param {Object} props
 * @returns {React.ReactElement}
 */
function ButtonList(props) {
    const { type } = props;
    const { fetch, load } = useList("button", type);

    const activityID = Commons.useActivityID();

    const data = Store.useState("button");
    const { loading, canEdit, list, total, sort } = data;

    const { deleteElem } = Store.useAction("button");

    // The Current State
    const [ action, elemID, startAction, endAction ] = Action.useActionID();


    // Handles the Edit Submit
    const handleEdit = () => {
        endAction();
        fetch();
    };

    // Handles the Delete Submit
    const handleDelete = async () => {
        endAction();
        const result = await deleteElem(elemID);
        if (result.success) {
            fetch();
        }
    };


    // Do the Render
    const elemName = Utils.getValue(list, "buttonID", elemID, "name");

    return <Main>
        <Header message="BUTTONS_NAME" icon="button">
            <ActionList data={data} onAction={startAction} />
        </Header>
        <Content>
            <Table
                fetch={load}
                sort={sort}
                none="BUTTONS_NONE_AVAILABLE"
                isLoading={loading}
                hasTabs
            >
                <TableHead>
                    <TableHeader field="name"       message="GENERAL_NAME"     isTitle />
                    <TableHeader field="buttonType" message="BUTTONS_TYPE"     />
                    <TableHeader field="content"    message="BUTTONS_CONTENT"  />
                    <TableHeader field="status"     message="GENERAL_STATUS"   align="center" maxWidth="100" />
                    <TableHeader field="position"   message="GENERAL_POSITION" maxWidth="80" align="center" hideMobile />
                </TableHead>
                <TableBody>
                    {list.map((elem) => <TableRow key={elem.buttonID} elemID={elem.buttonID}>
                        <TableCell message={elem.name}           />
                        <TableCell message={elem.buttonTypeName} />
                        <TableCell message={elem.content}        />
                        <TableCell message={elem.statusName}     textColor={elem.statusColor} />
                        <TableCell message={elem.position}       />
                    </TableRow>)}
                </TableBody>
                <TablePaging total={total} />
                <TableActionList onAction={startAction} canEdit={canEdit}>
                    <TableAction action="EDIT"   message="BUTTONS_EDIT_TITLE"   />
                    <TableAction action="COPY"   message="BUTTONS_COPY_TITLE"   />
                    <TableAction action="DELETE" message="BUTTONS_DELETE_TITLE" />
                </TableActionList>
            </Table>
        </Content>

        <ButtonEdit
            open={action.isVCCE}
            isCopy={action.isCopy}
            elemID={elemID}
            activityID={activityID}
            onSubmit={handleEdit}
            onClose={endAction}
        />
        <DeleteDialog
            open={action.isDelete}
            title="BUTTONS_DELETE_TITLE"
            message="BUTTONS_DELETE_TEXT"
            content={elemName}
            onSubmit={handleDelete}
            onClose={endAction}
        />
    </Main>;
}

/**
 * The Property Types
 * @typedef {Object} propTypes
 */
ButtonList.propTypes = {
    type : PropTypes.string.isRequired,
};

export default ButtonList;
